import * as React from "react";
// styles/components/seasonal-content-hub/'
// eslint-disable-next-line
const GA_MEASUREMENT_ID = 'G-NSEKRQF5TF';

const scriptContent = ({ pageTitle }: { pageTitle: any }) => `
{
    "vars" : {
      "gtag_id": "${GA_MEASUREMENT_ID}",
      "config" : {
        "${GA_MEASUREMENT_ID}": { 
            "groups": "default",
            "page_title": "${pageTitle} [AMP PAGE]",
            "ampHost": "\${ampdocHost}",
            "extraUrlParams": {
                "cd1": "\${ampdocHost}"
            }
        }
      }
    }
}
`;

export function AmpAnalyticsScript() {
  return (
    <script
      async={true}
      custom-element="amp-analytics"
      src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
    ></script>
  );
}

type AmpAnalyticsProps = {
  pageTitle?: string;
};

export function AmpAnalytics({ pageTitle }: AmpAnalyticsProps) {
  return (
    <amp-analytics type="gtag" data-credentials="include">
      <script
        type="application/json"
        dangerouslySetInnerHTML={{ __html: scriptContent({ pageTitle }) }}
      ></script>
    </amp-analytics>
  );
}
